// Provincias INE (nombre oficial que valida Provincias.xml)
export const INE_PROVINCIAS_APARTAMENTOS = [
  { code: "01", value: "ARABA/ALAVA", label: "01 - ARABA/ALAVA" },
  { code: "02", value: "ALBACETE", label: "02 - ALBACETE" },
  { code: "03", value: "ALICANTE", label: "03 - ALICANTE" },
  { code: "04", value: "ALMERIA", label: "04 - ALMERIA" },
  { code: "05", value: "AVILA", label: "05 - AVILA" },
  { code: "06", value: "BADAJOZ", label: "06 - BADAJOZ" },
  { code: "07", value: "BALEARES", label: "07 - BALEARES" },
  { code: "08", value: "BARCELONA", label: "08 - BARCELONA" },
  { code: "09", value: "BURGOS", label: "09 - BURGOS" },
  { code: "10", value: "CACERES", label: "10 - CACERES" },
  { code: "11", value: "CADIZ", label: "11 - CADIZ" },
  { code: "12", value: "CASTELLON", label: "12 - CASTELLON" },
  { code: "13", value: "CIUDAD REAL", label: "13 - CIUDAD REAL" },
  { code: "14", value: "CORDOBA", label: "14 - CORDOBA" },
  { code: "15", value: "A CORUÑA", label: "15 - A CORUÑA" },
  { code: "16", value: "CUENCA", label: "16 - CUENCA" },
  { code: "17", value: "GIRONA", label: "17 - GIRONA" },
  { code: "18", value: "GRANADA", label: "18 - GRANADA" },
  { code: "19", value: "GUADALAJARA", label: "19 - GUADALAJARA" },
  { code: "20", value: "GUIPUZKOA", label: "20 - GUIPUZKOA" },
  { code: "21", value: "HUELVA", label: "21 - HUELVA" },
  { code: "22", value: "HUESCA", label: "22 - HUESCA" },
  { code: "23", value: "JAEN", label: "23 - JAEN" },
  { code: "24", value: "LEON", label: "24 - LEON" },
  { code: "25", value: "LLEIDA", label: "25 - LLEIDA" },
  { code: "26", value: "LA RIOJA", label: "26 - LA RIOJA" },
  { code: "27", value: "LUGO", label: "27 - LUGO" },
  { code: "28", value: "MADRID", label: "28 - MADRID" },
  { code: "29", value: "MALAGA", label: "29 - MALAGA" },
  { code: "30", value: "MURCIA", label: "30 - MURCIA" },
  { code: "31", value: "NAVARRA", label: "31 - NAVARRA" },
  { code: "32", value: "OURENSE", label: "32 - OURENSE" },
  { code: "33", value: "ASTURIAS", label: "33 - ASTURIAS" },
  { code: "34", value: "PALENCIA", label: "34 - PALENCIA" },
  { code: "35", value: "LAS PALMAS", label: "35 - LAS PALMAS" },
  { code: "36", value: "PONTEVEDRA", label: "36 - PONTEVEDRA" },
  { code: "37", value: "SALAMANCA", label: "37 - SALAMANCA" },
  { code: "38", value: "TENERIFE", label: "38 - TENERIFE" },
  { code: "39", value: "CANTABRIA", label: "39 - CANTABRIA" },
  { code: "40", value: "SEGOVIA", label: "40 - SEGOVIA" },
  { code: "41", value: "SEVILLA", label: "41 - SEVILLA" },
  { code: "42", value: "SORIA", label: "42 - SORIA" },
  { code: "43", value: "TARRAGONA", label: "43 - TARRAGONA" },
  { code: "44", value: "TERUEL", label: "44 - TERUEL" },
  { code: "45", value: "TOLEDO", label: "45 - TOLEDO" },
  { code: "46", value: "VALENCIA", label: "46 - VALENCIA" },
  { code: "47", value: "VALLADOLID", label: "47 - VALLADOLID" },
  { code: "48", value: "VIZCAKAIA", label: "48 - VIZCAKAIA" }, // ojo a la K
  { code: "49", value: "ZAMORA", label: "49 - ZAMORA" },
  { code: "50", value: "ZARAGOZA", label: "50 - ZARAGOZA" },
  { code: "51", value: "CEUTA", label: "51 - CEUTA" },
  { code: "52", value: "MELILLA", label: "52 - MELILLA" },
];

// Categorías por provincia (Llaves)
// Provincias específicas (03, 08, 12, 17, 25, 43, 46) solo permiten "0 Llaves"
// El resto usa el fallback "*"
// Categorías por provincia (Llaves)
export const INE_CATEGORIAS_APARTAMENTOS_BY_PROVINCIA = {
  "08": [{ value: "0", label: "0 llaves" }],
  17: [{ value: "0", label: "0 llaves" }],
  25: [{ value: "0", label: "0 llaves" }],
  43: [{ value: "0", label: "0 llaves" }],
  "03": [{ value: "0", label: "0 llaves" }],
  12: [{ value: "0", label: "0 llaves" }],
  46: [{ value: "0", label: "0 llaves" }],

  // Fallback resto España
  "*": [
    { value: "1", label: "1 llave" },
    { value: "2", label: "2 llaves" },
    { value: "3", label: "3 llaves" },
    { value: "4", label: "4 llaves" },
    // si quieres mantener 0 también:
    // { value: "0", label: "0 llaves" },
  ],
};
